module.exports = __webpack_public_path__ + "static/media/369-celebration-small.639d6b8f.jpg";